module.exports = __webpack_public_path__ + "media/app/components/ChatSupport/Mascot.e01f7a47.svg";